// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__30cSL","productName":"Table_productName__2815J"};